import { inject, Service } from '@angular/core';
import type { Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxFilter } from '@onyx/angular';
import { OnyxFilterHelper, OnyxFilterOperator } from '@onyx/angular';
import { IntercomService } from '../../dashboard/common/services/intercom.service';

@Service()
export class FilterHelper {
  private readonly intercomService = inject(IntercomService);
  private readonly translateService = inject(TranslateService);

  public reportMissingFilter(screenTranslateKey: string): void {
    this.intercomService.startConversation(
      this.translateService.instant(
        'issues.reportMissingFilterIntercomMessage',
        { screen: this.translateService.instant(screenTranslateKey) },
      ),
    );
  }

  public static buildQueryParams(filters: OnyxFilter[] = []): Params {
    const params: Params = {};

    for (const filter of filters) {
      if (!OnyxFilterHelper.hasValue(filter)) continue;

      const { key, operator, value } = filter;
      const identifier = (operator: OnyxFilterOperator): string =>
        `filter[${key}][${operator}]`;

      switch (operator) {
        case OnyxFilterOperator.RANGE:
          if (value.from != null) {
            params[identifier(OnyxFilterOperator.GTE)] = value.from;
          }
          if (value.to != null) {
            params[identifier(OnyxFilterOperator.LTE)] = value.to;
          }
          break;

        case OnyxFilterOperator.IN:
          params[identifier(OnyxFilterOperator.IN)] = value.join(',');
          break;

        default:
          params[identifier(operator)] = value;
          break;
      }
    }

    return params;
  }
}
